export const topicsData = [
  { id: 1, name: '明星八卦', heat: '9.8万', tag: '热议', icon: 'ri-fire-line' },
  { id: 2, name: '网红爆料', heat: '8.5万', tag: '新瓜', icon: 'ri-flashlight-line' },
  { id: 3, name: '娱乐圈内幕', heat: '7.2万', tag: '深扒', icon: 'ri-eye-line' },
  { id: 4, name: '社会热点', heat: '6.9万', tag: '追踪', icon: 'ri-radar-line' },
  { id: 5, name: '直播翻车', heat: '6.1万', tag: '实锤', icon: 'ri-live-line' },
  { id: 6, name: '综艺争议', heat: '5.4万', tag: '热议', icon: 'ri-tv-line' },
  { id: 7, name: '影视吐槽', heat: '5.0万', tag: '辣评', icon: 'ri-movie-line' },
  { id: 8, name: '音乐圈风云', heat: '4.6万', tag: '内幕', icon: 'ri-music-line' },
  { id: 9, name: '体育猛料', heat: '4.2万', tag: '独家', icon: 'ri-basketball-line' },
  { id: 10, name: '科技圈大瓜', heat: '3.8万', tag: '爆料', icon: 'ri-cpu-line' },
];

export const aboutData = {
  title: '关于我们',
  description: '黑料官网是国内领先的娱乐资讯聚合平台，致力于为广大网友提供51黑料官网、黑料官网入口及黑料网官网的一站式访问指引。我们实时追踪黑料网最新地址与黑料网永久地址，确保用户能够通过黑料网首页链接快速直达内容主页，彻底解决找入口难的痛点。平台聚合娱乐圈、网红圈、社会热点等多维度爆料内容，以真实、及时、全面的态度服务每一位访问者。',
  stats: [
    { value: '500万+', label: '月活跃用户' },
    { value: '10万+', label: '累计爆料' },
    { value: '24h', label: '地址更新' },
  ],
};

export const contactData = {
  title: '联系我们',
  subtitle: '投稿爆料 · 商务合作 · 问题反馈',
  description: '如果您有独家爆料线索、商务合作意向或网站使用问题，欢迎通过以下方式与我们取得联系。我们重视每一条反馈，并将在第一时间予以响应。',
  email: 'contact@heilia.life',
  wechat: 'heilia_official',
  tips: [
    '投稿请附带详细时间线及佐证材料',
    '商务合作请注明合作类型与品牌信息',
    '地址失效反馈将优先处理并更新',
  ],
};

export const indexData = [
  { id: 1, title: '本月劲爆合集', count: 128, tag: '精选', coverSeq: 'index-cover-1' },
  { id: 2, title: '明星塌房全记录', count: 96, tag: '专题', coverSeq: 'index-cover-2' },
  { id: 3, title: '网红翻车现场', count: 87, tag: '热门', coverSeq: 'index-cover-3' },
  { id: 4, title: '综艺名场面盘点', count: 74, tag: '合集', coverSeq: 'index-cover-4' },
  { id: 5, title: '年度最佳吃瓜', count: 63, tag: '推荐', coverSeq: 'index-cover-5' },
  { id: 6, title: '娱乐圈潜规则揭秘', count: 55, tag: '深度', coverSeq: 'index-cover-6' },
  { id: 7, title: '直播圈爱恨情仇', count: 48, tag: '连载', coverSeq: 'index-cover-7' },
  { id: 8, title: '音乐人私生活曝光', count: 42, tag: '独家', coverSeq: 'index-cover-8' },
  { id: 9, title: '体育明星场外故事', count: 39, tag: '新番', coverSeq: 'index-cover-9' },
];

export const mediaData = [
  {
    id: 1,
    title: '独家揭秘：顶流艺人合约纠纷内幕全解析',
    duration: '15:28',
    views: '128万',
    date: '2026-07-28',
    tag: '独家',
    coverSeq: 'media-cover-1',
  },
  {
    id: 2,
    title: '实拍直击：某知名网红直播间翻车全过程',
    duration: '08:42',
    views: '96万',
    date: '2026-07-25',
    tag: '实锤',
    coverSeq: 'media-cover-2',
  },
  {
    id: 3,
    title: '深度追踪：娱乐圈资本博弈背后的隐秘故事',
    duration: '22:15',
    views: '85万',
    date: '2026-07-22',
    tag: '深度',
    coverSeq: 'media-cover-3',
  },
];

export const carouselData = [
  {
    id: 1,
    title: '2026上半年十大娱乐事件回顾',
    subtitle: '那些刷爆社交平台的惊天大瓜',
    description: '从一线明星婚变到顶流偶像塌房，从网红圈互撕到综艺争议升级——回顾上半年最引人注目的娱乐事件，带你一次吃个够。',
    tag: '年度盘点',
    date: '2026-07-30',
    coverSeq: 'carousel-cover-1',
  },
  {
    id: 2,
    title: '娱乐圈隐婚艺人名单曝光',
    subtitle: '多位一线明星被爆已秘密成家',
    description: '据知情人士透露，娱乐圈多位当红艺人早已秘密结婚，其中不乏粉丝心中的"单身偶像"。本文逐一核实并整理相关信息。',
    tag: '重磅',
    date: '2026-07-29',
    coverSeq: 'carousel-cover-2',
  },
  {
    id: 3,
    title: '网红经济泡沫破裂？头部主播接连翻车',
    subtitle: '直播带货神话正在被打破',
    description: '近一个月来，多位头部带货主播因产品质量、虚假宣传等问题接连翻车，引发行业震动。网红经济的"黄金时代"是否正在落幕？',
    tag: '深度',
    date: '2026-07-27',
    coverSeq: 'carousel-cover-3',
  },
  {
    id: 4,
    title: '选秀节目暗箱操作完整证据链',
    subtitle: '从投票造假到合约陷阱的前因后果',
    description: '一份流传于业内的内部文件揭示了选秀节目背后的完整操作流程，包括投票数据篡改、合约霸王条款以及选手被操控的真相。',
    tag: '实锤',
    date: '2026-07-24',
    coverSeq: 'carousel-cover-4',
  },
  {
    id: 5,
    title: '娱乐圈资源争夺战：谁是幕后赢家',
    subtitle: '资本、人脉与流量的三角博弈',
    description: '娱乐圈从来不只是台前的光鲜亮丽，幕后资源争夺比任何一部宫斗剧都精彩。揭秘各大经纪公司之间的明争暗斗与利益纠葛。',
    tag: '内幕',
    date: '2026-07-20',
    coverSeq: 'carousel-cover-5',
  },
];

export const appData = {
  title: '移动端访问入口',
  subtitle: '随时随地，吃瓜不迷路',
  description: '关注黑料官网移动端入口，获取黑料网最新地址推送，确保您在任何设备上都能第一时间直达内容主页。支持主流浏览器访问，无需下载额外应用。',
  features: [
    { icon: 'ri-smartphone-line', text: '移动端适配' },
    { icon: 'ri-notification-3-line', text: '地址更新推送' },
    { icon: 'ri-shield-check-line', text: '安全访问保障' },
    { icon: 'ri-speed-mini-line', text: '极速加载体验' },
  ],
};

export const rankingData = [
  { rank: 1, title: '某顶流艺人偷税漏税被罚数亿', heat: '🔥 156万', trend: 'up', tag: '爆' },
  { rank: 2, title: '知名导演被曝剧组潜规则多名女演员', heat: '🔥 132万', trend: 'up', tag: '热' },
  { rank: 3, title: '头部网红直播间售假被立案调查', heat: '🔥 118万', trend: 'up', tag: '热' },
  { rank: 4, title: '当红小生深夜私会神秘女子被拍', heat: '98万', trend: 'new', tag: '新' },
  { rank: 5, title: '综艺节目剪辑恶意丑化嘉宾引众怒', heat: '87万', trend: 'up', tag: '热' },
  { rank: 6, title: '影视公司对赌协议失败内幕全曝光', heat: '76万', trend: 'new', tag: '新' },
];

export const commentsData = [
  {
    id: 1,
    author: '吃瓜一线群众',
    avatar: 'R',
    time: '2小时前',
    content: '这个网站真的太及时了！之前老地址失效了找了好久，现在有了黑料网最新地址汇总页面，再也不用担心找不到入口了。内容更新也很快，每天早上第一件事就是来刷一遍。',
    likes: 1286,
  },
  {
    id: 2,
    author: '资深八卦研究员',
    avatar: '八',
    time: '5小时前',
    content: '关注黑料官网三年了，从最早到处找黑料网入口到现在一站直达，体验越来越好。特别是话题分类做得越来越细，想看什么类型的爆料都能快速找到，墙裂推荐给所有爱吃瓜的朋友！',
    likes: 967,
  },
  {
    id: 3,
    author: '娱乐圈观察员',
    avatar: '圈',
    time: '8小时前',
    content: '说实话市面上类似的导航站不少，但黑料官网的地址更新是最快的。每次黑料网网址有变动，这里都是第一时间同步。而且没有任何弹窗广告，体验很干净。已经安利给周围所有喜欢看娱乐资讯的朋友了。',
    likes: 843,
  },
];

export const updatesData = [
  { id: 1, title: '黑料网最新地址已同步更新（2026-07-30）', time: '今天 14:30', tag: '地址更新' },
  { id: 2, title: '新增"明星塌房全记录"专题合集上线', time: '今天 10:15', tag: '新专题' },
  { id: 3, title: '本月热门话题榜单已刷新，娱乐圈内幕登顶', time: '昨天 18:00', tag: '榜单' },
  { id: 4, title: '移动端访问体验全面升级，加载速度提升40%', time: '昨天 12:00', tag: '升级' },
  { id: 5, title: '黑料网永久地址已加入收藏页面快捷入口', time: '2天前', tag: '功能' },
  { id: 6, title: '新增"网红翻车现场"专题，收录87个经典案例', time: '3天前', tag: '新专题' },
  { id: 7, title: '用户反馈渠道已优化，地址失效可一键提交', time: '4天前', tag: '优化' },
  { id: 8, title: '首页索引模块改版，专题查找更加便捷', time: '5天前', tag: '改版' },
  { id: 9, title: '2026下半年内容规划公布，更多独家爆料筹备中', time: '6天前', tag: '公告' },
];

export const faqData = [
  {
    id: 1,
    question: '黑料官网是什么？',
    answer: '黑料官网是一个专注于提供51黑料官网、黑料官网入口及黑料网官网访问指引的聚合平台。我们实时追踪并更新黑料网最新地址与黑料网永久地址，帮助用户通过黑料网首页链接快速直达内容主页，同时聚合展示热门话题、专题合集等娱乐资讯内容。',
  },
  {
    id: 2,
    question: '如何获取黑料网最新地址？',
    answer: '您可以直接访问本站首页，我们在顶部区域会实时同步黑料网最新地址。同时建议您收藏本页作为常驻入口，或关注我们的移动端页面，确保在黑料网网址变动时能够第一时间获取最新有效链接。',
  },
  {
    id: 3,
    question: '黑料网永久地址真的永久有效吗？',
    answer: '黑料网永久地址是指在正常运营期间持续有效的访问地址。但受网络环境影响，任何网址都可能出现临时不可访问的情况。本站会以最快速度更新替代地址，并将永久地址作为首选推荐，确保用户的访问体验不受影响。',
  },
  {
    id: 4,
    question: '本站与黑料网是什么关系？',
    answer: '黑料官网是独立的导航与资讯聚合平台，帮助用户便捷地找到黑料网入口并了解最新娱乐资讯动态。我们提供地址指引、话题聚合和专题整合服务，但不直接运营黑料网的内容，用户可以放心通过本站链接访问目标页面。',
  },
  {
    id: 5,
    question: '如何投稿或提供爆料线索？',
    answer: '欢迎通过本站"联系我们"板块提供的邮箱或联系方式进行投稿。请附带详细的时间线、人物信息和佐证材料，我们的编辑团队会对每一条投稿进行核实和评估。对于有价值的一手爆料，我们将优先处理并在平台上予以展示。',
  },
];

export const cardsData = [
  {
    id: 1,
    title: '娱乐圈税务风暴：多名艺人被约谈',
    summary: '继某顶流艺人偷税案曝光后，税务部门已约谈多位知名艺人，娱乐圈税务合规问题再度引发热议。',
    date: '2026-07-30',
    tag: '重磅',
    coverSeq: 'card-cover-1',
  },
  {
    id: 2,
    title: '网红直播带货行业迎来最强监管',
    summary: '国家市场监管总局发布最新指导意见，针对直播带货中虚假宣传、数据造假等问题进行全面整治。',
    date: '2026-07-29',
    tag: '政策',
    coverSeq: 'card-cover-2',
  },
  {
    id: 3,
    title: '某知名男团成员被曝私联粉丝多年',
    summary: '多张聊天记录截图在社交平台疯传，当事人工作室尚未作出正式回应，粉丝群体出现严重分裂。',
    date: '2026-07-28',
    tag: '爆料',
    coverSeq: 'card-cover-3',
  },
  {
    id: 4,
    title: '影视行业寒冬加剧：多部大制作停摆',
    summary: '受投资方撤资和票房预期下调影响，超过20部原定年内开机的影视项目宣布无限期推迟。',
    date: '2026-07-26',
    tag: '行业',
    coverSeq: 'card-cover-4',
  },
  {
    id: 5,
    title: '音乐综艺被指暗箱操作排名引争议',
    summary: '多位参赛选手联合发声，指控节目组在淘汰环节存在不公平操作，节目口碑出现断崖式下跌。',
    date: '2026-07-24',
    tag: '争议',
    coverSeq: 'card-cover-5',
  },
  {
    id: 6,
    title: '体育圈跨界娱乐圈：运动员转型之路',
    summary: '越来越多运动员在退役后选择进军娱乐圈，有人风生水起有人水土不服，深度分析背后的成败逻辑。',
    date: '2026-07-22',
    tag: '深度',
    coverSeq: 'card-cover-6',
  },
  {
    id: 7,
    title: '社交媒体时代，明星公关策略大变革',
    summary: '从"沉默是金"到"主动出击"，明星应对危机的方式正在发生根本性变化，这背后是舆论生态的改变。',
    date: '2026-07-20',
    tag: '观点',
    coverSeq: 'card-cover-7',
  },
];

export const featuresData = [
  {
    id: 1,
    title: '地址实时更新',
    description: '专人全天候监测黑料网网址变动，确保黑料网最新地址第一时间同步，解决用户找入口难的痛点。支持多渠道验证，保障每一个黑料网链接的有效性和安全性。',
    icon: 'ri-refresh-line',
  },
  {
    id: 2,
    title: '内容聚合精选',
    description: '从海量娱乐资讯中精选最具话题性的爆料内容，按话题、热度、时间等维度分类展示。涵盖明星八卦、网红爆料、娱乐圈内幕、综艺争议、影视吐槽等多元品类。',
    icon: 'ri-stack-line',
  },
  {
    id: 3,
    title: '安全稳定访问',
    description: '所有推荐的黑料网入口均经过安全检测，排除恶意跳转和钓鱼链接。提供黑料网永久地址作为长期可靠入口，同时支持移动端无障碍访问，确保用户信息安全与浏览体验。',
    icon: 'ri-shield-check-line',
  },
];

export const footerLinks = {
  nav: [
    { name: '首页', href: '#hero' },
    { name: '联系我们', href: '#contact' },
    { name: '精选内容', href: '#cards' },
    { name: '平台特色', href: '#features' },
    { name: '关于我们', href: '#about' },
  ],
  topics: [
    { name: '明星八卦', href: '#topics' },
    { name: '网红爆料', href: '#topics' },
    { name: '娱乐圈内幕', href: '#topics' },
    { name: '社会热点', href: '#topics' },
    { name: '专题索引', href: '#index' },
  ],
  help: [
    { name: '常见问题', href: '#faq' },
    { name: '联系我们', href: '#contact' },
    { name: '移动入口', href: '#app' },
    { name: '最新快讯', href: '#updates' },
  ],
};